import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { AdoConfig } from '../models/ado-config.model';

@Injectable({
  providedIn: 'root',
})
export class AdoConfigService {
  currentApp: AdoConfig;

  appLayoutConfigs: { [key: string]: AdoConfig } = {
    CQP: {
      hasHeader: false,
      hasFooter: false,
      adoName: 'CMS QIO Platform',
      pageTitle: 'CMS QIO Platform',
      adoLogo: '../../../../assets/images/CQP-logo_white.svg',
      adoLogoAlt: 'CQP Logo - main',
      hasPrivacyPolicy: true,
      hasCustomBg: true,
      hasHarpResources: false,
    },
    MFT: {
      hasHeader: false,
      hasFooter: false,
      adoName: 'Managed File Transfer',
      pageTitle: 'Managed File Transfer',
      adoLogo: '../../../../assets/images/MFT-logo_white.svg',
      adoLogoAlt: 'MFT Logo - main',
      hasPrivacyPolicy: true,
      hasCustomBg: true,
      hasHarpResources: false,
    },
    QNP: {
      hasHeader: false,
      hasFooter: false,
      adoName: 'QualityNet Workspace',
      pageTitle: 'QualityNet Workspace',
      adoLogo: '../../../../assets/images/QNP-logo_white.svg',
      adoLogoAlt: 'QNP Logo - main',
      hasPrivacyPolicy: true,
      hasCustomBg: true,
      hasHarpResources: false,
    },
    HARP: {
      hasHeader: true,
      hasFooter: true,
      adoName: 'HCQIS Access Roles and Profile',
      pageTitle: 'HARP',
      adoLogo: '../../../../assets/images/HARP-logo_white.svg',
      adoLogoAlt: 'HARP Logo - main',
      hasPrivacyPolicy: false,
      hasCustomBg: false,
      hasHarpResources: true,
    },
  };

  constructor(private titleService: Title) {
    this.setCurrentApp();
    this.setPageTitle();
  }

  private setCurrentApp() {
    const urlParams = new URL(window.location.toString()).searchParams;
    const adoName = urlParams.get('ADO');
    const adoApp = this.appLayoutConfigs[adoName];
    this.currentApp = adoApp || this.appLayoutConfigs.HARP;
  }

  private setPageTitle() {
    const currentTitle = this.titleService.getTitle();
    this.titleService.setTitle(
      currentTitle.replace('HARP', this.currentApp.pageTitle),
    );
    this.titleService.getTitle();
  }

  public getCurrentApp() {
    return this.currentApp;
  }
}
